//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Possum_info'

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/Possum_info.vue